<template>
  <el-dialog
      :visible="visible"
      :before-close="() => {visible = false}"
      class="write-dialog"
      >
      <div class="tip-left">
        <div></div>
        <div @click="toWritePost()">写文章</div>
      </div>
        <p class="tip-line"></p>
      <div class="tip-right">
        <div></div>
        <div @click="toUpCourse()">传课程</div>
      </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'write-dialog',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    async toWritePost(){
      await window.open('/writepost/new')
      // this.visible = false
    },
	toUpCourse(){
      window.open('/upcourse/new')
    }
  }
}
</script>
<style lang="scss" scoped>
  .tip-left{
    >div:nth-child(1){
      width: 103px;
      height: 102px;
      background-image: url('~@/assets/img/writearticle.png');
      background-size: cover;
      margin: 49px 0px 32px 64px;
    }
    >div:nth-child(2){
      width: 100px;
      height: 38px;
      background-color: red;
      margin: 0px 0px 0px 64px;
      border-radius:19px;
      font-size:16px;
      font-family:MicrosoftYaHei-Bold;
      font-weight:bold;
      color:rgba(255,255,255,1);
      line-height: 38px;
      text-align: center;
      cursor: pointer;
    }
  }
  .tip-line{
    width:1px;
    height:214px;
    background-color:rgba(151,151,151,1);
    margin: 28px 65px 0px 64px;
    border-left:1px solid #EAEAEA;
  }
  .tip-right{
    >div:nth-child(1){
      width: 102px;
      height: 102px;
      background-image: url('~@/assets/img/upcourse.png');
      background-size: cover;
      margin: 49px 65px 32px 0px;
    }
    >div:nth-child(2){
      width: 100px;
      height: 38px;
      background-color: red;
      margin: 0px 64px 0px 0px;
      border-radius:19px;
      font-size:16px;
      font-family:MicrosoftYaHei-Bold;
      font-weight:bold;
      color:rgba(255,255,255,1);
      line-height: 38px;
      text-align: center;
      cursor: pointer;
    }
  }
</style>
<style lang="scss">
.write-dialog{
  display: flex;
  align-items: center;
  >.el-dialog{
    width:464px;
    height:270px;
    background:rgba(255,255,255,1);
    border-radius:6px;
    border:1px solid rgba(151,151,151,1);
    >.el-dialog__header{
      height: 0px;
      padding: 0px !important;
      >.el-dialog__headerbtn{
        position: absolute;
        top: 5px;
        right: -36px;
        >.el-dialog__close{
          width: 14px;
          height: 14px;
          color:rgba(255,255,255,1);
        }
      }
    }
    >.el-dialog__body {
      padding: 0;
      height: 100%;
      align-items: center;
      justify-content: space-around;
      flex-direction: row;
      display: flex;
    }
  }
}
</style>


